import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WidgetContainer from '../widget-container';

import config from '../../../run-config';

const styles = {
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '15px',
  },
  gridContainer: {
    display: 'grid',
    margin: '15px',
  },
  locationContainer: {
    marginTop: '10px',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  spacing: {
    order: 100,
    width: '100%',
    height: '100px',
    textAlign: 'center',
    marginTop: '30px',
  },
};

class LocationContainer extends Component {
  componentDidMount() {
    const { loadLocations } = this.props;
    loadLocations();
  }

  getLocation(locationId) {
    const { selectedLocation, locations } = this.props;

    return locationId === -1 ? selectedLocation : locations.find(l => l.id === locationId);
  }

  renderContent() {
    const {
      comparisonDateRanges, locations, selectedLocation, useMultiLocationComparison, ...other
    } = this.props;

    if (!useMultiLocationComparison) {
      return (
        <div style={styles.flexContainer} className="widget-container">
          <WidgetContainer {...other} />
        </div>
      );
    }

    const dataIds = [{ reportDataId: 0, location: selectedLocation }]
      .concat(comparisonDateRanges.map(cdr => (
        {
          reportDataId: cdr.comparisonId,
          location: this.getLocation(cdr.locationId),
        }
      )));

    const locationHeaders = dataIds.map((id, i) => (
      <div key={`location:${id.location.id}`} style={{ gridColumn: i + 1, gridRow: 1 }}><h3>{id.location.name}</h3></div>
    ));

    const widgetContainers = dataIds.map((id, i) => (
      <WidgetContainer
        key={`reportdata_${id.reportDataId}`}
        gridColumn={i + 1}
        reportDataId={id.reportDataId}
        {...other}
        useDesktopLayout={false}
        inApp={false}
        location={id.location}
      />
    ));

    const gridContainerStyle = {
      ...styles.gridContainer,
      gridTemplateColumns: dataIds.map(() => '1fr').join(' '),
    };

    return (
      <div style={gridContainerStyle} className="widget-container">
        {locationHeaders}
        {widgetContainers}
      </div>
    );
  }

  render() {
    const { selectedLocation, locations, debug } = this.props;

    if (!selectedLocation) {
      if (debug) {
        return (
          <h1>No Selected Location ({locations && locations.length})</h1>
        );
      }

      return null;
    }

    return (
      <div>
        {this.renderContent()}
        <div style={styles.spacing}>
          {config.legalNotice}
        </div>
      </div>
    );
  }
}

LocationContainer.propTypes = {
  comparisonDateRanges: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  selectedLocation: PropTypes.object,
  useMultiLocationComparison: PropTypes.bool.isRequired,
  loadLocations: PropTypes.func.isRequired,
  inApp: PropTypes.bool.isRequired,
};

LocationContainer.defaultProps = {
  selectedLocation: null,
};

export default LocationContainer;
